import React from 'react';
import clsx from 'clsx';

export interface BadgeProps {
  color?: 'muted' | 'success' | 'warning' | 'error';
  size?: 'small';
  text?: string;
  className?: string;
  onClick?: () => void;
}

export const Badge: React.FC<BadgeProps> = ({
  className,
  size = 'small',
  color = 'muted',
  text = 'DRAFT',
}) => {
  return (
    <div
      className={clsx('inline-flex items-center justify-center rounded-[999px]', className, {
        'h-5 px-1.5 py-0.5': size === 'small',
        'bg-neutral-200 text-neutral-500': color === 'muted',
        'bg-green-100 text-green-700': color === 'success',
        'bg-yellow-100 text-yellow-700': color === 'warning',
        'bg-red-100 text-red-700': color === 'error',
      })}
    >
      <span className="text-label-sm justify-center text-center font-semibold uppercase">
        {text}
      </span>
    </div>
  );
};
